import { TextInput } from 'cpool-components/input/TextInput';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormField } from './FormField';
import { formatFormLabel } from '../formatFormLabel';

type FormTextInputProps<TFieldValues extends FieldValues> = {
    control: Control<TFieldValues>;
    disabled?: boolean;
    id: Path<TFieldValues>;
    label: string;
    labelClassName?: string;
    placeholder?: string;
    required?: boolean;
};

export const FormTextInput = <TFieldValues extends FieldValues>({
    control,
    disabled,
    id,
    label,
    labelClassName = 'h-8 w-[175px] shrink-0 justify-start',
    placeholder,
    required,
}: FormTextInputProps<TFieldValues>) => (
    <FormField<TFieldValues, string | null> control={control} name={id}>
        {({ error, onBlur, onChange, value }) => (
            <TextInput
                id={id}
                label={formatFormLabel(label, required)}
                value={value ?? ''}
                onBlur={onBlur}
                onChange={(event) => onChange(event.target.value)}
                placeholder={placeholder}
                disabled={disabled}
                labelClassName={labelClassName}
                error={error}
            />
        )}
    </FormField>
);
